module.exports = __webpack_public_path__ + "img/Qubit.fed72026.svg";